export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST'
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR'
export const REGISTER_USER_RECAPTCHA = 'REGISTER_USER_RECAPTCHA'
export const ADD_ADDRESS_ERROR = 'ADD_ADDRESS_ERROR'
export const RESET_ERROR_STATE = 'RESET_ERROR_STATE'
export const KICKBOX_SUCCESS = 'KICKBOX_SUCCESS'
export const KICKBOX_ERROR = 'KICKBOX_ERROR'
